import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const Steps = ({ selectedSteps }) => {
  console.log(selectedSteps.steps[0]);
  return (
    <Box sx={{ flexGrow: 1, px: { xs: 3, md: 4 }, pt: { xs: 2, md: 4 } }}>
      {selectedSteps === null ? (
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 2, sm: 12, md: 12 }}
          alignItems="flex-start"
        >
          <Grid item xs={4} sm={12} md={12}>
            <Box>
              <Typography
                sx={{
                  bgcolor: "primary.main",
                  px: 1,
                  mb: 2,
                  mt: 3,
                  borderRadius: 1,
                }}
                variant="h3"
              >
                Steps
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  px: 1,
                }}
                variant="h6"
              >
                Here are the instructions to access SivooTV+ from{" "}
                {selectedSteps?.platform === "Android"
                  ? "an"
                  : selectedSteps.platform === "Apple"
                  ? "an"
                  : "a"}{" "}
                {selectedSteps?.platform} {selectedSteps?.device} device.
              </Typography>
              <Box
                sx={{
                  pl: 4,
                  mt: 2,
                  "& ol": {
                    "& li": {
                      marginBottom: "5px",
                    },
                  },
                  fontSize: { xs: "16px", md: "18px" }
                }}
              >
                <ol className="steps">
                  <li>
                    Ensure you have completed the{" "}
                    <Link to="/plus/signup">sign up</Link> process
                  </li>
                  {selectedSteps?.steps?.map((step, index) => {
                    const link = step.link;
                    if (link) {
                      return (
                        <li key={index}>
                          {step.text}{" "}
                          <Link
                            to={link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {selectedSteps.platform === "Web"
                              ? "click to visit SivooTV+"
                              : "or click here for the app store"}
                          </Link>
                        </li>
                      );
                    } else {
                      return <li key={index}>{step.text}</li>;
                    }
                  })}
                </ol>
              </Box>
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default Steps;
